// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::v-deep :not(.v-icon_1jLwG){font-family:\"proxima-nova\",\"OpenSans\",\"Pridi\",\"NotoSans\",\"NotoSansSC\",\"NotoSansHebrew\",\"NotoSansJapanese\",\"Hiragino Kaku Gothic Pro\",\"Yu Gothic Medium\",\"Yu Gothic\",Meiryo,\"source-han-sans-japanese\",\"source-han-sans-korean\",\"source-han-sans-simplified-c\",Helvetica,Arial,sans-serif}.nsAddressForm_3LaoU .dualColumn_3HlQO{display:flex;align-content:space-between}.nsAddressForm_3LaoU .dualColumn_3HlQO .firstCol_1Y3dA{margin-right:20px}.optional_1ooNT{color:#bbbcbc}", ""]);
// Exports
exports.locals = {
	"v-icon": "v-icon_1jLwG",
	"nsAddressForm": "nsAddressForm_3LaoU",
	"dualColumn": "dualColumn_3HlQO",
	"firstCol": "firstCol_1Y3dA",
	"optional": "optional_1ooNT"
};
module.exports = exports;
